import React from "react";
import { VStack, HStack } from "native-base";
import { Section } from "~/shared/Theme";
import { DarkSkeleton } from "~/shared/DarkSkeleton";

export const MessagesSkeleton = () => {

    return (
        <Section
            justifyContent='center'
            w='100%'
            h='100%'
        >
            <VStack width="100%" space={'2px'} mt={'4px'}>
                <VStack space={'2px'}>
                    <DarkSkeleton h={'22px'} w={'50%'} alignSelf={'center'} />
                    <DarkSkeleton height={'350px'} width="100%" />
                </VStack>
                <VStack space={'4px'} py={'8px'}>
                    <DarkSkeleton height={'18px'} width="90%" alignSelf={'center'} />
                    <DarkSkeleton height={'18px'} width="60%" alignSelf={'center'} />
                    <DarkSkeleton height={'18px'} width="30%" alignSelf={'center'} />
                </VStack>

                <HStack space={'4px'} py={'32px'}>
                    <DarkSkeleton ml={'5%'} w="50%" h="75" />
                    <DarkSkeleton ml={'5%'} w="50%"  h="75" />
                </HStack>
            </VStack>
        </Section>
    );
};
